import { render, staticRenderFns } from "./CourseDate.vue?vue&type=template&id=1a3e62fb&scoped=true"
import script from "./CourseDate.vue?vue&type=script&lang=js"
export * from "./CourseDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3e62fb",
  null
  
)

export default component.exports